import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';

function createData(
    name: string,
    description: string,
    extra: string
) {
    return { name, description, extra };
}

const rows = [
    createData(
        'Empresas subsidiarias o afiliadas de Profuturo', 
        'El ofrecimiento y promoción de sus servicios',
        'No necesario, ya que las empresas del mismo Grupo operan bajo políticas vinculantes de protección de datos'),
    createData(
        'Empresas del mismo grupo empresarial al que pertenece y, Sociedades con nexo patrimonial con Profuturo', 
        'El ofrecimiento y promoción de sus servicios',
        'Necesario<br/>(Tácito)'),
    createData(
        'Cualquier autoridad legalmente facultada que requiera la información por escrito', 
        'Cumplimiento de obligaciones',
        'No necesario'),
    createData(
        'Soy Más de las Américas, S. de R.L. de C.V. (Soy+)', 
        'Gestionar su participación e inscripción en el programa de lealtad Soy+, ya sea directamente o a través de empresas subsidiarias o afiliadas de Profuturo o del mismo grupo empresarial o consorcio al que pertenece o de Sociedades con las que Profuturo tenga nexo patrimonial',
        'Necesario<br/>(Tácito)'),
];

function BasicTable() {

    return (
        <TableContainer component={Paper} 
            sx={{
                border: '2px solid #477EFD80',
                borderRadius: '20px',
                boxShadow: 'none',
            }}>
            <Table sx={{ borderCollapse: 'collapse', tableLayout: 'fixed' }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                        <TableCell 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Destinatario de los datos personales</TableCell>
                        <TableCell 
                            align="left" 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Finalidad</TableCell>
                        <TableCell 
                            align="left" 
                            className='title_table'
                            sx={{ borderBottom: '1px solid #477EFD80' }}>Consentimiento o excepción</TableCell>
                        </TableRow>
                    </TableHead>
                <TableBody>
                    {rows.map((row) => (
                    <TableRow
                        key={row.name}
                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                        <TableCell 
                            className='text_table' 
                            component="th" 
                            scope="row"
                            sx={{ borderBottom: '1px solid #477EFD80' }}>
                        {row.name}
                        </TableCell>
                        <TableCell 
                            className='text_table' 
                            align="right"
                            sx={{ borderBottom: '1px solid #477EFD80' }}>{row.description}
                        </TableCell>
                        <TableCell 
                            className='text_table' 
                            align="right"
                            sx={{ borderBottom: '1px solid #477EFD80' }}
                            dangerouslySetInnerHTML={{ __html: row.extra}}/>
                        {/* </TableCell> */}
                    </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
        );
}

const Transferencia = () => {
    return (
        <main className='container_aviso'>
            <section className='container_tab'>
                <div className='container_transferencia'>
                    <p className='subtitle_aviso'>Transferencias De Datos Personales</p>
                    <p className='text_general'>Se le informa que los datos personales que proporciona podrán transferirse a estas entidades públicas y/o privadas.<br/><br/></p>
                    <BasicTable /><br />
                    <p className='text_fot_table'>
                        Profuturo no realizará transferencias sin su consentimiento a otros terceros no mencionados anteriormente.<br /><br />
                    </p>
                    <div className='divider'></div><br />
                </div>
            </section>
        </main>
    )
}
export default Transferencia